module.exports = __webpack_public_path__ + "static/media/otp.c3f80534.png";